function removeElements(text) {
  if (typeof text === 'object') {
    return text;
  }
  var div = document.createElement('div');
  div.innerHTML = text;
  return div.textContent || div.innerText || '';
}

function joinUrl(...args) {
  return args
    .filter(Boolean)
    .map((part, index) => {
      // Remove starting slash except for the first part if it contains protocol
      if (index > 0) part = part.replace(/^\/+/, '');
      // Remove trailing slash for all parts
      return part.replace(/\/+$/, '');
    })
    .join('/');
}

function fnCheckTypeMessage(type, msgCust, sitetpx) {
  if (type == 'flex') {
    return msgCust.altText + '\n\n....';
  } else if (type == 'image') {
    var msg =
      '<a href="' +
      msgCust +
      '" target="_blank"><img src="' +
      msgCust +
      '" class="ui-path-img"></a>';
    return msg;
  } else if (type == 'url') {
    var linkUrl = msgCust.match(/(https?:\/\/[^\s]+)/g);
    for (let j = 0; j < linkUrl.length; j++) {
      msgCust = msgCust.replace(
        linkUrl[j],
        '<a href="' + linkUrl[j] + '" target="_blank">' + linkUrl[j] + '</a>',
      );
    }

    return msgCust;
  } else if (type == 'string') {
    var codeMush = msgCust.match(/[MmUuSsHh]{4}[0-9]{6}/g);
    var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/; // eslint-disable-line
    var mushCode = '';
    if (regex.test(msgCust)) {
      var urlRegex = /(https?:\/\/[^\s]+)/g;
      var newMsg = msgCust.replace(urlRegex, function(url) {
        if (
          url.indexOf('.png') > 0 ||
          url.indexOf('.jpg') > 0 ||
          url.indexOf('.jpeg') > 0
        ) {
          let img =
            '<a href="' +
            url +
            '" target="_blank"><img src="' +
            url +
            '" class="ui-path-img"></a>';
          return img;
        } else {
          return '<a href="' + url + '"  target="_blank">' + url + '</a>';
        }
      });
      mushCode = newMsg;
    } else if (codeMush != null && codeMush.length > 0) {
      const siteName = String(sitetpx || 'https://m.tourprox.com');
      codeMush.forEach(val => {
        mushCode = msgCust.replace(
          val,
          `<a href="${joinUrl(
            siteName,
            '/Booking/Main.aspx?act=search&typeName=bot&tCode=',
          )}` +
            val +
            '" target="_blank">' +
            val +
            '</a>',
        );
      });
    } else {
      mushCode = msgCust;
    }
    return mushCode;
  }
}

export function convertChatHtml(type, message) {
  const noHtmlMessage = removeElements(message);
  return fnCheckTypeMessage(type, noHtmlMessage);
}



// WEBPACK FOOTER //
// ./src/functions/format-string.js